import { useEffect, useState } from 'react'
import { Box, Button, Grid2, Typography, IconButton, Badge } from '@mui/material';
import { Field, Form, Formik } from 'formik';
import { useTicketDropdownOptions } from './TicketOption';
import TableFilterTemplate from '../../../shared/utils/TableFilterTemplate';
import { AutoCompleteField } from '../../../shared/components/formfields/AutoCompleteField';
import { useGetAllTickets } from '../../../assets/nodeApi/getApi/getAdminApi';
import MainDialogBox from '../../../shared/components/Dialog/MainDialogBox';
import { useDialog } from '../../../shared/hook/useDialog';
import { IdAutoCompleteField } from '../../../shared/components/formfields/IdAutoCompleteField';
import { useAllUserList } from '../../../assets/api/useAdminApi';
import CustomDivider from '../../../shared/utils/CustomDivider';
import { Grid_Gap } from '../../../shared/constants';
import * as Yup from "yup";
import { patchAssignTicket } from '../../../assets/nodeApi/patchApi/PatchAdminApi';
import { useToaster } from '../../../shared/utils/ToasterProvider';
import { queryClient } from '../../../assets/nodeApi/reactQueryClient';
import { useMutation } from '@tanstack/react-query';
import { postTicketChat } from '../../../assets/nodeApi/postApi/postCommonApi';
import { useGetTicketsChatsById } from '../../../assets/nodeApi/getApi/getCommonApi';
import { socket } from '../../../socket';
import useAuthStore from '../../../store/useAuthStore';
import ChatIcon from '@mui/icons-material/Chat';
import { patchMarkAllRead } from '../../../assets/nodeApi/patchApi/patchCommonApi';
import ChatModule from '../../../shared/components/ChatModule';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getFileUrl } from '../../../shared/utils/getFileUrl';



const TicketList = () => {
    //  const [selectedTicket, setSelectedTicket] = useState({});
    const { user } = useAuthStore();
    const [selectedTicketForChat, setSelectedTicketForChat] = useState({});
    const [filters, setFilters] = useState({});
    const { data: ticketList, isLoading } = useGetAllTickets(filters)
    const [selectedTicket, setSelectedTicket] = useState({})
    const { priorityLevel, ticketStatus, ticketCategory } = useTicketDropdownOptions()
    const { open, handleClickOpen, handleClose } = useDialog();
    const { open: openAttachment, handleClickOpen: handleClickOpenAttachment, handleClose: handleCloseAttachment } = useDialog();
    const [selectedRole, SetSelectedRole] = useState(null)
    const { data: userList, isLoading: isAssignToUserLoading } = useAllUserList({ role: selectedRole })
    const { data: chatData, isLoading: isChatLoading } = useGetTicketsChatsById(selectedTicketForChat?.id);
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [messages, setMessages] = useState([]);
    const [raisedTicketCounts, setRaisedTicketCounts] = useState({});

    const { showToaster } = useToaster();

    const UserListOption = userList?.data?.map((item) => ({
        id: item?.id,
        value: item?.firstname,
        label: item?.firstname
    })) || [];

    const ticketOption =
        ticketList?.tickets?.map((item, index) => ({
            id: item.id,
            label: item?.ticketId,
            value: item?.ticketId,
            sr_no: index + 1,
            ...item
        })) ?? [];


    const mutationSendChat = useMutation({
        mutationFn: (formData) => postTicketChat(formData),
    });

    const mutationMarkAsRead = useMutation({
        mutationFn: (id) => patchMarkAllRead(id),
    });

    const handleViewChat = (row) => {
        setSelectedTicketForChat(row);
        setIsChatOpen(true);
        mutationMarkAsRead.mutate(row?.id);
        setMessages([])

    };


    const handleViewTicket = (row) => {
        handleClickOpenAttachment();
        setSelectedTicket(row);
    };

    const ticketColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 0.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "ticketId",
            headerName: "Ticket Id",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "category",
            headerName: "Category",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "priority",
            headerName: "Priority",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params?.value}</Typography>
        },
        {
            field: "status",
            headerName: "Status",
            flex: 0.8,

            renderCell: (params) => <Typography variant="body2">{params?.value}</Typography>
        },
        {
            field: "createdby",
            headerName: "Created By",
            flex: 0.8,
            renderCell: (params) => <Typography variant="body2">{params?.row?.createdBy?.firstname}{""}{params?.row?.createdBy?.lastname}</Typography>
        },
        {
            field: "assign",
            headerName: "Assign Ticket",
            flex: 1,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => {
                        handleClickOpen()
                        setSelectedTicket(params)
                    }}
                >
                    Assign
                </Button>
            ),
        },
        {
            field: "attachments",
            headerName: "Attachments",
            flex: 1,
            renderCell: (params) => (
                <IconButton onClick={() => handleViewTicket(params?.row)} size="small">
                    <VisibilityIcon color="text.primary" />
                </IconButton>
            ),
        },
        {
            field: "chat",
            headerName: "Conversation",
            flex: 1,
            renderCell: (params) => (
                <IconButton
                    // color="primary"
                    onClick={() => handleViewChat(params.row)}
                >
                    <Badge
                        badgeContent={raisedTicketCounts[params.row.id]?.unread || 0}
                        color="error"
                    >
                        <ChatIcon />
                    </Badge>
                </IconButton>
            ),
        },


    ];


    const mutationAssign = useMutation({
        mutationFn: ({ formData, id }) => patchAssignTicket(formData, id),
    });

    const handleSubmit = (values, { resetForm }) => {
        const payload = {
            agentId: values?.agentId
        };
        mutationAssign.mutate({ formData: payload, id: selectedTicket.id }, {
            onSuccess: () => {
                showToaster('Ticket Assign  successfully!', '', 'success');
                queryClient.invalidateQueries(['tickets']);
                resetForm()
                handleClose()
            },
            onError: (err) => {
                showToaster(err?.response?.data?.error || 'Failed to Assign Ticket', '', 'error');
            },
        });
    };

    useEffect(() => {
        const ticketId = selectedTicketForChat?.id;
        const userId = user?.id;
        if (!ticketId || !userId) return;

        // Join ticket-specific room
        socket.emit("joinTicket", { ticketId, userId });
        console.log(`🟢 Joined chat room for ticket_${ticketId}`);

        // Load messages from API
        if (chatData?.data?.length) setMessages(chatData.data);

        // Listen for new messages
        const handleNewMessage = (newMsg) => {
            if (newMsg.ticketId === ticketId) {
                setMessages((prev) => [...prev, newMsg]);
            }
        };
        socket.on("newMessage", handleNewMessage);

        return () => {
            console.log(`🚪 Leaving chat room for ticket_${ticketId}`);
            socket.emit("leaveTicket", { ticketId, userId });
            socket.off("newMessage", handleNewMessage);
        };
    }, [selectedTicketForChat?.id, user?.id, chatData]);


    useEffect(() => {
        const userId = user?.id;
        if (!userId) return;

        const handleChatCountUpdate = (data) => {
            setRaisedTicketCounts((prev) => ({
                ...prev,
                [data.ticketId]: {
                    unread: data.unreadCount,
                    total: data.totalMessageCount,
                },
            }));
        };

        socket.on("chatCountUpdate", handleChatCountUpdate);

        return () => {
            socket.off("chatCountUpdate", handleChatCountUpdate);
        };
    }, [user?.id]);

    useEffect(() => {
        if (ticketList?.tickets?.length) {
            const initialCounts = {};
            ticketList.tickets.forEach((t) => {
                initialCounts[t.id] = {
                    unread: t.messageCounts?.unread || 0,
                    total: t.messageCounts?.total || 0,
                };
            });
            setRaisedTicketCounts(initialCounts);
        }
    }, [ticketList]);

    const handleSubmitChat = (values, { resetForm, setSubmitting }) => {
        const payload = {
            ticketId: selectedTicketForChat?.id,
            receiverId: selectedTicketForChat?.createdBy?.id,
            message: values.message,
            messageType: "text"
        };
        mutationSendChat.mutate(payload, {
            onSuccess: () => {
                socket.emit("sendMessage", payload);
                resetForm();
                setSubmitting(false);
            },
            onError: (err) => {
                showToaster('Error', err?.response?.data?.error || 'Failed to send', 'error');
                setSubmitting(false);
            },
        });
    };

    return (
        <>
            <Box
                sx={{
                    position: "relative",
                    pointerEvents: isChatOpen ? "none" : "auto", // 🚫 disables interaction
                    opacity: isChatOpen ? 0.4 : 1,              // 🌑 dim effect
                    transition: "opacity 0.3s ease",
                }}
            >
                <TableFilterTemplate
                    title="Ticket List"
                    columns={ticketColumns}
                    rowsData={ticketOption || []}
                    isLoading={isLoading}
                    filterInitialValues={filters}
                    filterReset={() => setFilters({})}
                    onApplyFilters={(f) => setFilters(f)}

                    renderFilterFields={() => (
                        <>
                            <Grid2 children size={12}>
                                <Field
                                    name="priority"
                                    component={AutoCompleteField}
                                    options={priorityLevel.options}
                                    label="Priority Level"

                                />
                            </Grid2>
                            <Grid2 children size={12}>
                                <Field
                                    name="category"
                                    component={AutoCompleteField}
                                    options={ticketCategory.options}
                                    label="Ticket Category"

                                />
                            </Grid2>
                            <Grid2 children size={12}>
                                <Field
                                    name="status"
                                    component={AutoCompleteField}
                                    options={ticketStatus.options}
                                    label="Ticket Status"

                                />
                            </Grid2>
                        </>
                    )}
                />
            </Box>
        
            {isChatOpen && (
                <ChatModule
                    selectedTicket={selectedTicketForChat}
                    onClose={() => {
                        setSelectedTicketForChat({});
                        setIsChatOpen(false);
                    }}
                />
            )}


            <MainDialogBox open={open} handleClose={handleClose} width={"40%"} heading={"Assign Ticket"}>
                <Typography variant='body2'>

                </Typography>
                <CustomDivider />
                <Formik
                    initialValues={{}}

                    validationSchema={Yup.object().shape({})}

                    onSubmit={handleSubmit}

                >
                    {() => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>

                                <Grid2 children size={12}>
                                    <Field
                                        name="assign_to"
                                        label="Assign To"
                                        component={AutoCompleteField}
                                        options={[
                                            {
                                                id: 1, label: 'CTO', value: "CTO"
                                            },
                                            {
                                                id: 2, label: 'COO', value: "COO"
                                            }
                                        ]}
                                        onValueChange={(role) => SetSelectedRole(role?.value)}
                                        isRequired={true}

                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name={`agentId`}
                                        label="Agent Name"
                                        component={IdAutoCompleteField}
                                        options={selectedRole ? UserListOption : []}
                                        isRequired={true}


                                    />
                                </Grid2>

                                <Grid2 children size={12}>
                                    <Button variant='contained' type='submit' fullWidth disabled={mutationAssign.isPending}>
                                        {mutationAssign.isPending ? "Assigning" : "Assign"}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>

            <MainDialogBox open={openAttachment} handleClose={handleCloseAttachment} width={"50%"} heading={"Attachments List"}>
                <Grid2 container spacing={Grid_Gap}>
                    {selectedTicket?.attachments?.map((item, index) => (
                        <Grid2 key={index} size={6}>
                            <img src={getFileUrl(item?.url)} width={"100%"} alt="attachment" />
                        </Grid2>
                    ))}
                </Grid2>
            </MainDialogBox>
        </>
    )
}

export default TicketList;

